import React, { forwardRef, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@mui/material';

const ReactTableCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return <Checkbox ref={resolvedRef} {...rest} />;
});
ReactTableCheckbox.displayName = 'ReactTableCheckBox';
ReactTableCheckbox.defaultProps = {
  indeterminate: '',
};
ReactTableCheckbox.propTypes = {
  indeterminate: PropTypes.bool,
};
export { ReactTableCheckbox };
